<template>
  <div class="flex justify-start flex-wrap -mb-3" :class="{'flex-col':column, 'readonly':readonly, 'disabled':disabled}">
    <label v-for="(value, key) in options" :key="value.id ?? key" :class="type" class="ml-6 mb-3">
      <span v-if="type.indexOf('switch') !== -1" v-show="showLabel" class="control-label pr-3 pl-0">{{ value.label ?? value }}</span>
      <input
          :type="inputType"
          :name="name"
          v-model="computedValue"
          :value="value.id ?? key"
          :disabled="disabled"
          :readonly="readonly">
      <span class="check"></span>
      <span v-if="type.indexOf('switch') === -1" v-show="showLabel" class="control-label pr-3 pl-0">{{ value.label ?? value }}</span>
    </label>
  </div>
</template>

<style>
.readonly, .disabled {
    pointer-events: none;
    opacity: .9;
}
</style>

<script>
import { computed } from 'vue'

export default {
  name: 'CheckRadioPicker',
  props: {
    options: {
      type: Object,
      default: () => {}
    },
    name: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'checkbox'
    },
    showLabel: {
        type: Boolean,
        default: true
    },
    disabled: {
        type: Boolean,
        default: false
    },
    readonly: {
        type: Boolean,
        default: false
    },
    column: Boolean,
    modelValue: [String, Number, Boolean, Array]
  },
  emits: ['update:modelValue'],
  setup (props, { emit }) {
    const computedValue = computed({
      get: () => props.modelValue,
      set: value => {
        emit('update:modelValue', value)
      }
    })

    const inputType = computed(() => props.type === 'radio' ? 'radio' : 'checkbox')

    return {
      computedValue,
      inputType
    }
  }
}
</script>
